export const AuthConstants = {
  LoginSuccess: 'AUTH_CONSTANTS.LOGIN_SUCCESS',
  LoginFailure: 'AUTH_CONSTANTS.LOGIN_FAILURE',
  Logout: 'AUTH_CONSTANTS.LOGOUT',
  LoginError: 'AUTH_CONSTANTS.LOGIN_ERROR',
};

export const ForgotPasswordConstants = {
  EmailSent: 'FORGOT_PASSWORD_CONSTANTS.EMAIL_SENT',
  EmailNotSent: 'FORGOT_PASSWORD_CONSTANTS.EMAIL_NOT_SENT',
  ClearStatus: 'FORGOT_PASSWORD_CONSTANTS.CLEAR_STATUS',
};
